import Tag from '@allesauto/core/tag';
import TextLink from '@allesauto/core/textLink';
import translate from '@allesauto/i18n';
import React from 'react';
import { IntlShape, useIntl } from 'react-intl';

import { IReduxActionProps } from '@/store/redux/Utils';

import { TagPayload } from '../containers/FilterTagsContainer';

export interface FilterTag {
  deleteTag?: () => IReduxActionProps | null;
  tagText: (intl: IntlShape) => string;
  tagPayload: TagPayload;
}

interface FilterTagsProps {
  deleteAll?: () => IReduxActionProps | null;
  filterTags: FilterTag[];
}

const FilterTags = ({ deleteAll, filterTags }: FilterTagsProps) => {
  const intl = useIntl();

  return (
    <div className="mt-30px">
      {filterTags.map(
        (filterTag: FilterTag) =>
          filterTag.tagText(intl) && (
            <div
              className="inline-block mb-15px mr-20px"
              key={Object.values(filterTag.tagPayload)[0]}
            >
              <Tag
                text={filterTag.tagText(intl)}
                color={'primary'}
                {...(filterTag.deleteTag && {
                  onIconCloseClick: () =>
                    filterTag.deleteTag && filterTag.deleteTag(),
                })}
              />
            </div>
          )
      )}
      {filterTags.filter((filterTag: FilterTag) => filterTag.tagText(intl))
        .length > 1 && (
        <TextLink
          text={translate(intl, 'ui.PCP.TAGS.DELETE_ALL')}
          onClick={() => deleteAll && deleteAll()}
        />
      )}
    </div>
  );
};

export default FilterTags;
